import React from 'react';
import { hooks } from '@lifesize/clients.sdk';
import { VideoStream } from '@lifesize/clients.sdk/dist/components';
import classes from './PreviewVideo.module.scss';

const PreviewVideo = () => {
  const localPrimaryStream = hooks.useLocalPrimaryStream();
  return (
    <div className={classes.videoContainer}>
      <VideoStream style={{ position: 'relative' }} muted={true} mediaStream={localPrimaryStream.stream} />
    </div>
  );
};

export default PreviewVideo;
